﻿import { mapGetters, mapState } from 'vuex';
import errorMessage from './errorMessage.vue';

export default {
    name: 'ca-ctc',
    props: ['viewmodel'],
    components: {
        'ca-error-message': errorMessage
    },
    mounted: function () {
        this.$store.dispatch('setTexts', { 'customerEmail': 'Invalid email address' });

        if (this.salesChannel === 'PhysicalShop') {
            this.$store.watch(state => state.creditaccount.contracts.contractsSigned, (signed) => {
                document.getElementById('cbCTC').checked = signed;

                if (document.getElementById('cbCTFC') != null) {
                    document.getElementById('cbCTFC').checked = signed;
                }
            });
        }
    },
    methods: {
        enableCTCSelection: function () {
            if (this.order.useNewDiva) {
                if ((this.hasAnyTeliaContract == this.contracts.showTeliaContracts) && this.order.manualSigning) {
                    return false;
                }
                else if (!this.order.manualSigning) {
                    return false;
                }
                else {
                    return true
                }
            }
            else {
                if (this.contracts.showTeliaContracts && (this.showTFSummaryInformation == this.contracts.showTFContracts)) {
                    return false;
                }
                else {
                    return true;
                }
            }
        },
        acceptCTC: function (e) {
            this.$store.dispatch('acceptCTC', !this.contracts.checkCTC);
        },
        acceptCTFC: function (e) {
            this.$store.dispatch('acceptCTFC', !this.contracts.checkCTFC);
        },
        updateContractData: function (field, e) {
            this.$store.dispatch('updateContractData', { 'field': field, 'value': e.target.value });
        },
        validateEmail: function (e) {
            this.$store.dispatch('validateEmail', e.target.value);
        },
        setTooltipParagraph: function (tooltipTitle, tooltipText) {
            return '[{"title":"' + tooltipTitle + '","paragraph":"' + tooltipText + '"}]';
        }
    },
    computed:
        Object.assign(
            mapState({
                order: state => state.creditaccount.order,
                showTFSummaryInformation: state => state.creditaccount.showTFSummaryInformation,
                contracts: state => state.creditaccount.contracts,
                salesAgentEmail: state => state.creditaccount.contracts.salesAgentEmail,
                warnings: state => state.creditaccount.warnings,
                salesChannel: state => state.creditaccount.salesChannel,
            }),
            mapGetters({
                showCreditAgreementDetails: 'showCreditAgreementDetails',
                hasAnyContract: 'hasAnyContract',
                hasAnyTeliaContract: 'hasAnyTeliaContract'
            })
        )
}